<template>
    <v-row class="mb-2 mx-n1 mt-n1">
        <v-col cols="12" md="4" class="pa-1" v-for="{ color, title, MODEL_NAME, productionText, percentageProductive, percentageDefective } in items" :key="title">
            <v-card dark flat rounded="xl" v-bind="{ color }" width="67%" class="mx-auto mb-n4" style="z-index: 2">
                <v-card-title class="justify-center pa-1 subtitle-1">{{ title }}</v-card-title>
            </v-card>
            <v-card rounded="lg" v-bind="{ loading }" flat>
                <v-card-text class="pa-3 pt-6">
                    <v-row justify="center">
                        <v-col cols="auto" class="pa-2">
                            <v-progress-circular :value="percentageProductive" color="success" size="80" width="5" rotate="-90">
                                <v-layout column align-center>
                                    <div class="mt-1 caption font-weight-bold">생산률</div>
                                    <div class="mt-n2 text-h6 font-weight-bold">{{ percentageProductive }}%</div>
                                </v-layout>
                            </v-progress-circular>
                        </v-col>
                        <v-col cols="auto" class="pa-2">
                            <v-progress-circular :value="percentageDefective" color="error" size="80" width="5" rotate="-90">
                                <v-layout column align-center>
                                    <div class="mt-1 caption font-weight-bold">불량률</div>
                                    <div class="mt-n2 text-h6 font-weight-bold">{{ percentageDefective }}%</div>
                                </v-layout>
                            </v-progress-circular>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card rounded="lg" outlined color="transparent" class="mt-2" style="border-color: rgba(0, 0, 0, 0.12) !important">
                <v-card-text class="pa-3">
                    <v-row no-gutters justify="space-between" class="mx-auto" style="width: 210px">
                        <v-col class="caption" cols="4">모델명</v-col> <v-col cols="auto">{{ MODEL_NAME || "-" }}</v-col>
                    </v-row>
                    <v-row no-gutters justify="space-between" class="mx-auto" style="width: 210px">
                        <v-col class="caption" cols="4">작업수량</v-col> <v-col cols="auto">{{ productionText }}</v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import api from "@/api";

export default {
    props: {
        date: { type: String, default: Date.now().toDate() },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        line1: {},
        line2: {},
        line3: {},
    }),
    computed: {
        searchDateValue() {
            let start = this.$dayjs(this.date).startOf("day");
            let end = this.$dayjs(this.date).endOf("day");
            return [start, end].map((date) => date.toISOString());
        },
        items() {
            return [
                { title: "전자제조실장1라인", color: "#A3C614", ...this.line1 },
                { title: "전자제조실장2라인", color: "#FFC13A", ...this.line2 },
                { title: "보드조립라인", color: "#FF6839", ...this.line3 },
            ].map((item) => ({
                ...item,
                productionText: `${(+(item?.PROD_QTY || "0")).format()} / ${(+(item?.PLAN_QTY || "0")).format()}`,
                percentageProductive: item?.PROD_RATE?.match?.(/\d*/g)?.[0] || 0,
                percentageDefective: item?.BAD_RATE?.match?.(/\d*/g)?.[0] || 0,
            }));
        },
    },
    mounted() {
        this.search();
    },
    watch: {
        date() {
            this.search();
        },
    },
    methods: {
        async search() {
            let { searchDateValue } = this;
            let { schedules } = await api.console.mes.schedules.gets({ params: { searchDateValue } });

            let { line1, line2, line3 } = schedules.reduce(
                ({ line1, line2, line3 }, item) => ({
                    line1: item.LINE_NAME == "SMT 01라인" ? item : line1,
                    line2: item.LINE_NAME == "SMT 02라인" ? item : line2,
                    line3: item.LINE_NAME == "보드조립 01라인" ? item : line3,
                }),
                { line1: {}, line2: {}, line3: {} }
            );
            this.line1 = line1;
            this.line2 = line2;
            this.line3 = line3;
        },
    },
};
</script>

<style></style>
